import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <div className="w-24 h-24 md:w-28 md:h-28 mx-auto flex items-center justify-center rounded-full bg-background-100">
          <i className="ri-emotion-sad-line text-4xl md:text-5xl text-foreground-400"></i>
        </div>
        <h1 className="mt-6 text-3xl md:text-4xl font-heading font-bold text-foreground-900">
          页面未找到
        </h1>
        <p className="mt-2 text-sm md:text-base text-foreground-500">
          您访问的页面不存在或已被移除
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}